<template>
  <nuxt-link :to="linkToArticle" class="text-mouse! no-underline! group block">
    <p v-if="article.category !== 'None'" class="uppercase mb-1 text-sm">
      <strong class="text-rhino">{{ article.category }}</strong>
    </p>
    <div class="flex justify-between items-center gap-4">
      <h3 class="mb-0 uppercase text-lg font-bold">
        {{ article.title }}
      </h3>
      <fa-icon
        :icon="faCircleArrowRight"
        class="size-6 text-brand shrink-0 mx-2"
      />
    </div>
    <p class="mb-0 text-rhino mt-1">{{ publishedAt }}</p>
  </nuxt-link>
</template>

<script setup lang="ts">
import { faCircleArrowRight } from '@fortawesome/pro-solid-svg-icons';
import type { StrapiArticle } from '~/apollo/types/types';
import {
  useArticleLink,
  useArticlePublishedDate,
} from '../../features/useArticleFeatures';

const props = defineProps<{
  article: StrapiArticle;
}>();

const article = toRef(props, 'article');
const { publishedAt } = useArticlePublishedDate(article, 'long');
const { linkToArticle } = useArticleLink(article);
</script>

<style scoped></style>
